import { render, staticRenderFns } from "./CheckCell.vue?vue&type=template&id=2f4fb2cd&scoped=true"
import script from "./CheckCell.vue?vue&type=script&lang=js"
export * from "./CheckCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4fb2cd",
  null
  
)

export default component.exports